module.exports = __webpack_public_path__ + "static/media/hero-picture.53d7caea.png";